import ErrorFallback from 'Components/ErrorFallback'
import ReportPage from 'Services/SalesManagement/Features/Report/Pages/ReportPage'
import { ErrorBoundary } from 'react-error-boundary'
import { Route, Routes } from 'react-router-dom'

const ReportRoot = () => {
  return (
    <ErrorBoundary FallbackComponent={ErrorFallback}>
      <Routes>
        <Route index element={<ReportPage />} />
      </Routes>
    </ErrorBoundary>
  )
}
export default ReportRoot
